import {z} from 'zod';

export const FormSchema = z.object({
	name: z.string().min(1, {
		message: 'Navn må fylles ut',
	}),
	email: z.string().email({
		message: 'Må være en gyldig e-postadresse',
	}),
	phone: z.string().min(1, {
		message: 'Telefonnummer må fylles ut',
	}),
	message: z.string().min(1, {
		message: 'Melding må fylles ut',
	}),
});
